import { motion } from "framer-motion";
import {
  card,
  cardTitle,
  microLabel,
  bodySecondary,
  dividerInner,
  motionStaggerChild,
} from "../../../lib/design-system";
import { cn } from "../../../lib/utils";

export default function CourseDetailsComponents({ course }) {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const schedule = course?.courseSchedule;
  if (!schedule) return null;

  const dateRows = [
    { label: "Class Start", value: formatDate(schedule.classStartDate) },
    { label: "Class End", value: formatDate(schedule.classEndDate) },
    { label: "Mid-Sem Exam", value: formatDate(schedule.midSemesterExamDate) },
    { label: "End-Sem Exam", value: formatDate(schedule.endSemesterExamDate) },
  ];

  return (
    <div className={cn(card, "overflow-hidden")}>
      {/* Header */}
      <div className={cn("p-6 border-b", dividerInner)}>
        <h3 className={cardTitle}>Schedule</h3>
      </div>

      <div className="p-6 space-y-3">
        {dateRows.map((row, i) => (
          <motion.div
            key={row.label}
            {...motionStaggerChild(i)}
            className="flex items-center justify-between"
          >
            <span className={microLabel}>{row.label}</span>
            <span className="text-sm text-gray-900 dark:text-white">
              {row.value}
            </span>
          </motion.div>
        ))}

        {schedule.classDaysAndTimes?.length > 0 && (
          <>
            <div className={cn("border-t my-3", dividerInner)} />
            <p className={cn(microLabel, "mb-2")}>Class Days & Times</p>
            {schedule.classDaysAndTimes.map((session, index) => (
              <motion.div
                key={index}
                {...motionStaggerChild(dateRows.length + index)}
                className="flex items-center justify-between"
              >
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {session.day}
                </span>
                <span className={bodySecondary}>{session.time}</span>
              </motion.div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
